export const taskNavigation_actionType = {
    USER_DETAILS : "User Details",
    SELECT_ROLES_OR_GROUPS: 'Select Roles'
};